import { GET_APPLICATION_LOG_CONFIGURATIONS_REQUESTED } from "../types/types";

export default () => ({
    type: GET_APPLICATION_LOG_CONFIGURATIONS_REQUESTED,
});